import { PropsWithChildren } from 'react';

import { useResponsive } from '@/hooks/useResponsive';

import { Modal, ModalProps } from '../Modal';
import { ModalSize } from '../Modal.constants';
import { BottomSheetDrawer } from './BottomSheetDrawer';

type BottomSheetModalProps = PropsWithChildren<{
  modalProps?: ModalProps;
  size?: ModalSize;
  onClose?: () => void;
}>;

export function BottomSheetModal({
  modalProps,
  children,
  onClose,
}: Readonly<BottomSheetModalProps>) {
  const { isDesktop, isTablet } = useResponsive();

  if (isDesktop || isTablet) {
    return (
      <Modal {...modalProps} onClose={onClose}>
        {children}
      </Modal>
    );
  }

  return (
    <BottomSheetDrawer onClose={onClose} modalProps={modalProps}>
      {children}
    </BottomSheetDrawer>
  );
}
